<div class="national-team-page">
    <nav class="cat__core__top-sidebar cat__core__top-sidebar--bg d-block d-lg-flex justify-content-between">
    <span class="cat__core__title d-block mt-2 mb-2 ml-2">
        <strong>
            <span>National Partners: </span>
            <span>{{currentNationalTeamName()}}</span>
        </strong>
    </span>
        <div class="d-sm-flex align-items-center page-actions">
            <a class="btn btn-primary btn-sm ml-2"
               *ngIf="pageService?.nationalTeamPage?.fullUrl"
               (click)="hybridToolsService.openExternalLink(pageService?.nationalTeamPage?.fullUrl)" target="_blank">View page</a>
            <button class="btn btn-primary btn-sm edit-team ml-2 d-sm-inline-block d-none"
                    *ngIf="!nationalTeamsService?.selectedNationalTeam?.isPastNationalTeam && nationalTeamsService?.selectedNationalTeam?.cssClass !== 'program-soy' && nationalTeamsService?.selectedNationalTeam?.cssClass !== 'program-svoy'"
                    (click)="openchangeTeamModal()">Edit team name and logo</button>
            <button class="btn btn-primary btn-sm edit-team ml-2 d-inline-block d-sm-none"
                    *ngIf="!nationalTeamsService?.selectedNationalTeam?.isPastNationalTeam && nationalTeamsService?.selectedNationalTeam?.cssClass !== 'program-soy' && nationalTeamsService?.selectedNationalTeam?.cssClass !== 'program-svoy'"
                    (click)="openchangeTeamModal()">Edit</button>
        </div>
    </nav>

    <div class="row data-grid-wrapper">
        <div class="col-lg-12">
            <div class="cat__core__sortable" id="bottom-col">
                <section class="card" order-id="card-13">
                    <div class="card-body">
                        <lls-datagrid [options]="teamsGridOptions" #teamsTable></lls-datagrid>
                    </div>
                </section>
            </div>
        </div>
    </div>
</div>
